<template>
  <VModal class="no-padding" :showing="showing" container-classes="max-w-3xl max-h-3xl" @update:showing="$emit('update:showing', $event)">
    <div class="p-4 bg-gray-100 smp-6">
      <h2 class="mb-0 text-lg font-medium text-gray-900">Edit Image</h2>
      <p class="mb-0 text-sm text-gray-700">Manipulate and crop your image below using the controls in the bottom left.</p>
    </div>
    <Cropper
      ref="cropperRef"
      class="w-auto h-auto"
      :src="url"
      :default-size="fillArea"
      :stencil-props="{ aspectRatio: aspectRatio }"
      @change="onChange"
    />
    <div class="flex items-center justify-start p-6 space-x-4">
      <VButton data-testid="zoom-in-btn" size="sm" variant="light" @click="zoomIn">
        <MagnifyingGlassPlusIcon class="w-5 h-5 text-gray-700" />
      </VButton>
      <VButton data-testid="zoom-out-btn" size="sm" variant="light" @click="zoomOut">
        <MagnifyingGlassMinusIcon class="w-5 h-5 text-gray-700" />
      </VButton>
      <VButton data-testid="rotate-left-btn" size="sm" variant="light" @click="rotateLeft">
        <ArrowUturnLeftIcon class="w-5 h-5 text-gray-700" style="transform: scaleX(-1)" />
      </VButton>
      <VButton data-testid="rotate-right-btn" size="sm" variant="light" @click="rotateRight">
        <ArrowUturnLeftIcon class="w-5 h-5 text-gray-700" />
      </VButton>
      <div class="flex items-center justify-end flex-1">
        <VButton data-testid="cancel-btn" size="lg" variant="light" @click="$emit('update:showing', false)">Cancel</VButton>
      </div>
      <div class="flex items-center justify-end">
        <VButton data-testid="save-btn" size="lg" variant="copper" @click="saveEdits">Save</VButton>
      </div>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'
import 'vue-advanced-cropper/dist/style.css'
import { Cropper } from 'vue-advanced-cropper'
import { ArrowUturnLeftIcon } from '@heroicons/vue/24/solid'
import { MagnifyingGlassMinusIcon, MagnifyingGlassPlusIcon } from '@heroicons/vue/24/solid'

const props = defineProps({
  showing: {
    type: Boolean,
    default: false,
  },
  file: {
    type: File,
    required: true,
  },
  aspectRatio: {
    type: Number,
    default: 16 / 9,
  },
})

const emit = defineEmits(['update:showing', 'on-edits-completed'])

const { editorElement: cropperRef, zoomIn, zoomOut, rotateLeft, rotateRight, fillArea } = useImageEditor()

const url = computed(() => URL.createObjectURL(props.file))

let imageGraphicElement: { canvas: { toBlob(...args: any): void } } | null = null

function onChange(changes: any) {
  imageGraphicElement = changes
}

function saveEdits() {
  imageGraphicElement?.canvas.toBlob((blob: any) => {
    emit('on-edits-completed', new File([blob], props.file.name || '', { type: props.file.type }))
  }, props.file.type)
}
</script>
